import HTTP from '../libs/HTTP';


//query接口返回参数
export interface IRequirementHistoryInfoList {
    records: IRequirementHistoryInfo[],
}

export interface IRequirementHistoryInfo {
    id: number,
    requirementId: number,
    requirementName: string,
    sales: number, 
    salesName: string,
    states: number, 
    createTime: string,
}

//add接口请求参数
export interface RequirementHistoryPostParam {
    requirementId: number, 
    states: number, 
    createTime: string, 
}

//edit接口请求参数
export interface RequirementHistoryPutParam {
    id: number,
    states: number, 
    createTime: string, 
}


class RequirementHistoryService extends HTTP {
    //根据需求id查询需求历史记录
    async getRequirementHistoryByRequirementId(id: number) {
        const response = await this.get(`/requirement/getRequirementHistoryByRequirementId/${id}`);
        if (response) {
            return response.data;
        }
    }

    //根据id查询需求历史记录
    async getRequirementHistoryById(id: number) {
        const response = await this.get(`/requirement/getRequirementHistoryById/${id}`);
        if (response && response.data) {
            return response.data;
        }
    }

    //添加需求历史记录
    async addRequirementHistory(request: RequirementHistoryPostParam) {
        const response = await this.post('/requirement/addRequirementHistory', request, {
            params: {
                requirementId: request.requirementId, 
                states: request.states, 
                createTime: request.createTime, 
            },
        });
        if (response) {
            return response.data;
        }
    }

    //编辑需求历史记录
    async updateRequirementHistory(request: RequirementHistoryPutParam) {
        const response = await this.put(`/requirement/updateRequirementHistory/${request.id}`, request, {
            params: {
                states: request.states, 
                createTime: request.createTime, 
            },
        });
        if (response) {
            return response.data;
        }
    }

    //删除需求历史记录
    async deleteRequirementHistory(id: number) {
        const response = await this.delete(`/requirement/deleteRequirementHistory/${id}`);
        if (response) {
            return response.data;
        }
    }

}
export default new RequirementHistoryService();
